@if (pipeline()) {
  <glxy-form-field
    [prefixText]="'OPPORTUNITY.STAGE.SELECTOR.LABEL' | translate"
    [hideRequiredLabel]="true"
    bottomSpacing="none"
    class="select"
  >
    <mat-select
      [formControl]="stageCtrl"
      [placeholder]="'OPPORTUNITY.STAGE.SELECTOR.TITLE' | translate"
      [value]="stageId()"
    >
      @for (stage of stages(); track $index) {
        <mat-option [value]="stage.id">
          {{ stage.name }}
        </mat-option>
      }
    </mat-select>
  </glxy-form-field>
}
